"use strict";

require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.date.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("Core/Body");
var Step2Selectors_1 = require("Components/Cart/Step2/Step2Selectors");
var decimal_js_1 = require("decimal.js");
exports.Step2Summary = function () {
  var COMMON = Step2Selectors_1.Step2Selectors.COMMON,
    PAYMENT_METHODS = Step2Selectors_1.Step2Selectors.PAYMENT_METHODS;
  var VAT = 23;
  var Selectors = {
    SUMMARY_PANEL: '.summary-panel',
    SUM_PAYMENT_BUTTON: '.method-payment',
    SUM_ORDER: '#js_sum_order',
    SUM_DELIVERY: '#js_sum_delivery_order_2',
    SUM_DELIVERY_EXTENCE: '#js_sum-delivery-extence-price',
    SUM_PRICE: '#js_sum_payment',
    SUMMARY_ORDER: '#js_summary_order',
    SUM_VAT: '#js_sum_vat'
  };
  function recalculateDelivery() {
    $('.payment_method_radio').each(function () {
      $(this).prop('checked', false);
    });
    var delivery = $(this).find('.method-delivery--price').data('price');
    var sum = showPrice(parseFloat(delivery), 'zł z VAT');
    $(Selectors.SUM_DELIVERY).data('price', delivery);
    $(Selectors.SUM_DELIVERY).text(sum);
    $(this).prev('input').prop('checked', true);
  }
  function recalculateDeliveryReload() {
    $('.payment_method_radio').each(function () {
      $(this).prop('checked', false);
    });
    $('.method-delivery').each(function () {
      if ($(this).find('input').is(':checked')) {
        var delivery = $(this).find('.method-delivery--price').data('price');
        var sum = showPrice(parseFloat(delivery), 'zł z VAT');
        $(Selectors.SUM_DELIVERY).data('price', delivery);
        $(Selectors.SUM_DELIVERY).text(sum);
        $(this).prev('input').prop('checked', true);
      }
    });
  }
  function recalculatePayment() {
    var payment = $(this).find('.method-payment--price').data('price');
    var sum = showPrice(parseFloat(payment), 'zł z VAT');
    $(Selectors.SUM_PRICE).data('price', payment);
    $(Selectors.SUM_PRICE).text(sum);
    $(this).prev('input').prop('checked', true);
  }
  function recalculateOrder() {
    calculateExtraDeliveryPrice();
    var order_price = new decimal_js_1.Decimal(parseFloat($(Selectors.SUM_ORDER).data('price')) || 0).toNumber();
    var delivery_price = new decimal_js_1.Decimal(parseFloat($(Selectors.SUM_DELIVERY).data('price')) || 0).toNumber();
    var delivery_ext_price = new decimal_js_1.Decimal(parseFloat($(Selectors.SUM_DELIVERY_EXTENCE).data('price')) || 0).toNumber();
    var payment = new decimal_js_1.Decimal(parseFloat($(Selectors.SUM_PRICE).data('price')) || 0).toNumber();
    var summary = order_price + delivery_price + delivery_ext_price + payment;
    var sum = showPrice(summary, 'zł');
    $(Selectors.SUMMARY_ORDER).text(sum);
    var order_price_vat_org = new decimal_js_1.Decimal(parseFloat($(Selectors.SUM_VAT).data('ordervat')) || 0).toNumber();
    var order_price_vat = calculateVat(order_price_vat_org, VAT);
    var delivery_prie_vat = calculateVat(delivery_price, VAT);
    var delivery_ext_price_vat = calculateVat(delivery_ext_price, VAT);
    var payment_vat = calculateVat(payment, VAT);
    var sumary_vat = order_price_vat + delivery_prie_vat + delivery_ext_price_vat + payment_vat;
    var sum_vat = showPrice(sumary_vat, 'zł');
    $(Selectors.SUM_VAT).text(sum_vat);
  }
  function calculateExtraDeliveryPrice() {
    var selectedDeliveryMethod = $(COMMON.SELECTED_DELIVERY_RADIO);
    if ($('input#cart_payment_method_4').is(':checked')) {
      var cod_price = $(selectedDeliveryMethod).next().find('.method-delivery--price').data('cod_price');
      var sum_cod_price = showPrice(parseFloat(cod_price), 'zł z VAT');
      $(Selectors.SUM_DELIVERY_EXTENCE).data('price', cod_price);
      $(Selectors.SUM_DELIVERY_EXTENCE).text(sum_cod_price);
    } else {
      $(Selectors.SUM_DELIVERY_EXTENCE).data('price', 0);
      $(Selectors.SUM_DELIVERY_EXTENCE).text(showPrice(parseFloat('0'), 'zł z VAT'));
    }
  }
  function calculateVat(brutto, percent) {
    var vat = brutto * percent / 100;
    return vat.toFixed(2);
  }
  function showPrice(price, currency) {
    price = parseFloat(price).toFixed(2);
    var parts = price.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    var formattedPrice = parts.join(",");
    return formattedPrice + " " + currency;
  }
  Body_1.$body.ready(recalculateDeliveryReload);
  Body_1.$body.on('click', COMMON.DELIVERY_TILE, recalculateDelivery);
  Body_1.$body.on('click', COMMON.DELIVERY_TILE, recalculateOrder);
  Body_1.$body.on('click', Selectors.SUM_PAYMENT_BUTTON, recalculatePayment);
  Body_1.$body.on('click', Selectors.SUM_PAYMENT_BUTTON, recalculateOrder);
  Body_1.$body.on('click', COMMON.DELIVERY_TILE, recalculateOrder);
}();